import { IDemoFlow, proposal, step } from './types';
import { DEMO_UAT_RECORDS } from './uatRecords';

// Example 4 Path C (`mode: modal`) on a record the backend already created: the builder opens by
// itself in edit mode on it, and its save is reported with `handoff_result`.

const { stampCampaign } = DEMO_UAT_RECORDS;

export const CAMPAIGN_CREATE_FLOWS: IDemoFlow[] = [
  {
    id: 'campaign-create',
    prompt: 'Create a stamp campaign for at risk customers',
    reply: now => ({
      outcome: 'action_proposed',
      answer: `I created the draft campaign ${stampCampaign.name} (#${stampCampaign.id}) and opened it in the builder.`,
      action: proposal(
        step('create_campaign', 'Create Campaign', {
          entity: 'campaign',
          id: stampCampaign.id,
          name: stampCampaign.name,
          state: 'draft',
          subtype: 'stamp'
        }),
        now,
        {
          mode: 'modal',
          buttons: [{ id: 'open_builder', label: 'Open in builder' }],
          builder: { form: 'campaign_edit', prefill: null }
        }
      )
    })
  }
];
